import React from 'react';
import { ShieldCheck, AlertTriangle, ShieldAlert } from 'lucide-react';

export const RiskScoreBadge = ({ riskLevel }) => {
    // LOW, MEDIUM, HIGH
    let config = {
        color: 'bg-green-100 text-green-800 border-green-200',
        label: 'RIESGO BAJO',
        icon: <ShieldCheck className="h-10 w-10 text-green-600 mb-2" />
    };

    if (riskLevel === 'MEDIUM') {
        config = {
            color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
            label: 'RIESGO MEDIO',
            icon: <AlertTriangle className="h-10 w-10 text-yellow-600 mb-2" />
        };
    } else if (riskLevel === 'HIGH') {
        config = {
            color: 'bg-red-100 text-red-800 border-red-200',
            label: 'RIESGO ALTO',
            icon: <ShieldAlert className="h-10 w-10 text-red-600 mb-2" />
        };
    }

    return (
        <div className={`flex flex-col items-center justify-center p-6 border rounded-2xl shadow-sm ${config.color}`}>
            {config.icon}
            <span className="text-xl font-bold tracking-tight">{config.label}</span>
        </div>
    );
};
